import styled from '@emotion/styled';
import { COLORS3 as COLORS, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const HeroSection = styled.div`
  display: flex;
  justify-content: start;
  min-height: 240px;
  position: relative;

  ${MEDIA_QUERY.EXCLUDE_MOBILE_XS} {
    min-height: 312px;
  }

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    justify-content: center;
  }

  ${MEDIA_QUERY.TABLET} {
    max-height: 500px;
  }

  ${MEDIA_QUERY.DESKTOP} {
    min-height: 240px;
    max-height: 400px;
  }

  ${MEDIA_QUERY.DESKTOP_XL} {
    min-height: 400px;
    max-height: 440px;
  }

  ${MEDIA_QUERY.DESKTOP_MASSIVE} {
    min-height: 440px;
    max-height: 705px;
  }
`;

export const MediaContainer = styled.div`
  height: auto;
  overflow: hidden;
  width: 100%;
`;

export const HeroImage = styled.img`
  width: 100vw;
`;

export const ContentWrapper = styled.div`
  bottom: 0;
  color: ${COLORS.WHITE_100};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: ${SPACING.S24};
  position: absolute;
  top: 0;
  text-align: left;

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    padding-left: 0;
    text-align: center;
  }

  h1 {
    font-size: ${FONT.FONT_SIZE_LARGER};
    line-height: 100%;

    ${MEDIA_QUERY.TABLET} {
      font-size: 42px;
    }

    ${MEDIA_QUERY.DESKTOP} {
      font-size: 64px;
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: block;
  margin-top: ${SPACING.S32};

  ${MEDIA_QUERY.MOBILE} {
    a:last-child {
      margin-top: ${SPACING.XS};
    }
  }

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    display: flex;
    flex-direction: row;
    justify-content: center;
    column-gap: ${SPACING.XS};
  }

  ${MEDIA_QUERY.DESKTOP} {
    margin-top: ${SPACING.S24};
  }

  ${MEDIA_QUERY.DESKTOP_XL} {
    margin-top: ${SPACING.S32};
  }
`;
